import { render, staticRenderFns } from "./ReturnRequestModal.vue?vue&type=template&id=463f2727"
import script from "./ReturnRequestModal.vue?vue&type=script&lang=js"
export * from "./ReturnRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports